import clsx from "clsx"

import { faIcon } from "@utils/faIcon"

import { Skeleton } from "@particles/index"

import { Icon, IconButton, Tooltip } from "@atoms"

import styles from "./SearchInputChrome.module.scss"
import { SearchInputChromeProps } from "./SearchInputChrome.types"

export default function SearchInputChrome(props: SearchInputChromeProps) {
    const {
        type,
        renderInput,

        showClearButton,
        onClear,

        isFullWidth = false,
        isLoading = false,
        isSearching = false,
        isDisabled = false,
        _isFocused,
        _isHovered,
    } = props

    return (
        <div
            className={clsx(styles.base, styles[`${type}Type`], {
                [styles.fullWidth]: isFullWidth,
                [styles.loading]: isLoading,
                [styles.disabled]: isDisabled,
                [styles.focused]: _isFocused,
                [styles.hovered]: _isHovered,
            })}
            aria-disabled={isDisabled}
            aria-busy={isLoading}
        >
            <div className={styles.searchAndInput}>
                <div className={styles.iconContainer}>
                    {isLoading ? (
                        <Skeleton circle={true} width={14} height={14} />
                    ) : (
                        <Icon
                            icon={faIcon({
                                name: isSearching ? "spinner-third" : "magnifying-glass",
                                style: "regular",
                            })}
                            container="square"
                            size={14}
                            spin={isSearching}
                            className={styles.icon}
                        />
                    )}
                </div>

                {isLoading ? <Skeleton width="100%" height={10} borderRadius={0} /> : renderInput(styles.input)}
            </div>

            {showClearButton && !isLoading && !isDisabled && (
                <Tooltip body="Clear">
                    <IconButton
                        size={type === "field" ? "sm" : "md"}
                        variant="ghost"
                        className={styles.clearButton}
                        icon={faIcon({ name: "circle-xmark", style: "solid" })}
                        onClick={onClear}
                        aria-label="Clear search"
                        noDebounce={true}
                    />
                </Tooltip>
            )}
        </div>
    )
}
